import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import tableResize from '@/directives/table-resize'

Vue.directive('resize-column', tableResize)

// 设计系统样式（必须在 Element UI 之后加载以覆盖）
import '@/styles/design-tokens.css'
import '@/styles/glassmorphism.css'
import '@/styles/global.css'
import '@/styles/responsive.css'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
